<template>
  <div class="" v-if="productDetail">
    <div class="container mt-5">
        <div class="row">
            <nav aria-label="breadcrumb" class="d-flex justify-content-end">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><a href="https://www.mywingio.com/" class="underline-none" >Home</a></li>
                    <li class="breadcrumb-item"><a href="javascript:void(0)" class="underline-none" @click="$router.push({ path: '/'})">Shop</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Product Detail</li>
                </ol>
            </nav>

            <!-- Product Images -->
            <div class="col-md-6 mb-4">
                <div class="img-card">
                    <div class="img-section">
                        <ul id="lightSlider" v-if="images.length > 0">
                            <li v-for="(image, index) in images" :key="index" :data-thumb="image">
                                <img :src="image" alt="Product Image" />
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Product Details -->
            <div class="col-md-6 text-start">
                <h2 class="text-start product-name unset-font-weight" >{{ productDetail.displayName }}</h2>
                <small class="text-start text-black unset-font-weight" >{{ productDetail.name }}</small>
                <div class="mb-3 text-start">
                    <span class="h4 me-2 unset-font-weight fs-3 text-primary">£{{ productDetail.stripePriceDetail.unit_amount / 100 }}</span>
                    <!--<span class="text-muted"><s>$399.99</s></span>-->  
                </div>
                <p class="mb-4 text-justify">{{ productDetail.shortDescription }}</p>
                <ul class="benefit-list">
                    <li class="benefit-item"><i class="fas fa-check-circle"></i> Standard shipping</li>
                    <li class="benefit-item"><i class="fas fa-check-circle"></i> Free returns</li>
                    <li class="benefit-item"><i class="fas fa-check-circle"></i> 30-day money back guarantee</li>
                </ul>
                <div class="mb-4 text-start">
                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-2 col-form-label">Quantity:</label>
                        <div class="col-sm-10">
                            <input type="number" class="form-control" v-model="qty" min="1" max="3" style="width: 80px;">
                        </div>
                    </div>
                </div>
                <p><b>You must get a SIM card and plan from the cellular carrier of your choice.</b></p>
                <div class="billing-container">
                    <div class="billing-option" v-for="prod in subscriptionProducts" :key="prod._id">
                        <input type="radio" v-model="subscriptionPriceId" :value="prod.stripePriceId" :id="prod.recurringIntervalType" name="billing" :checked="prod.recurringIntervalType == 'Monthly'">
                        <label :for="prod.recurringIntervalType" class="radio-card-content">
                            <span class="unset-font-weight">{{ prod.recurringIntervalType }} billing (60 Day Free)  <small class="text-warning-grey unset-font-weight"></small></span>
                            <span class="price unset-font-weight">£{{ prod.stripePriceDetail.unit_amount / 100 }}</span>
                        </label>
                    </div>
                </div>
                <div class="p-2 m-2">
                    <button class="btn btn-primary btn-sm" type="button" @click="addProductToCart(productDetail, true)" :disabled="isDisabled">Add To Cart <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span></button>&nbsp;
                </div>
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-md-6 mb-4">
                <h4 class="product-name unset-font-weight">Product Detail</h4>
                <div v-html="productDetail.longDescription"></div>
            </div>
            <div class="col-md-6 mb-4">
                <h4 class="product-name unset-font-weight">Subscription Details</h4>
                <p>Your subscription lets you manage your child's Wingio Device and customize settings to fit your family. From your computer or phone, login to the portal to:</p>
                <ul class="text-start">
                    <li>Manage child's device applications by installing/uninstalling it from parent portal.</li>
                    <li>Set daily limit for specific application to prevent over use of any application.</li>
                    <li>Group app into category and manage category daily limit.</li>
                    <li>Location tracking</li>
                    <li>Sleep mode for child to prevent over night use of device</li>
                </ul>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import PaymentService from "../services/PaymentService";

export default {
  name: 'Product Detail',
  components: {
    
  },
  props: {
  },
  data() {
    return {
      isDisabled: false,
      productDetail: null,
      productId: this.$route.query.id,
      images: [],
      qty: 1,
      subscriptionProducts: [],
      subscriptionPriceId: "",
      isSliderInitialized: false,
    };
  },
  methods: {
    async getProductDetail() {
        let data = { id: this.productId }
        await PaymentService.getProductDetail(data)
        .then((response) => {
          this.productDetail = response.data.data;
          this.subscriptionProducts =response.data.subscriptionProducts;
          this.subscriptionPriceId = this.subscriptionProducts[0].stripePriceId
          this.images = this.productDetail.images;
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async addProductToCart(product, redirectToCartPage = false) {
        this.isDisabled = true;
        let data = {
            productId: product._id,
            productDetail: product,
            qty: this.qty,
            subscriptionPriceId: this.subscriptionPriceId,
        }
        await PaymentService.addProductToCart(data)
        .then((response) => {
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            if (redirectToCartPage == true) {
                this.$router.push({ path: '/cart'}) 
            }
        }).catch((e) => {
            this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    initSliderWhenReady() {
        this.$nextTick(() => {
        const slider = $('#lightSlider');
        const images = slider.find('img');
        let loadedCount = 0;

        if (!images.length) {
            return;
        }

        images.each(function () {
            if (this.complete) {
            loadedCount++;
            } else {
            $(this).on('load', () => {
                loadedCount++;
                if (loadedCount === images.length) {
                initSliderNow();
                }
            });
            }
        });

        if (loadedCount === images.length) {
            initSliderNow();
        }

        function initSliderNow() {
            if (slider.hasClass('lightSlider-initialized')) return;
            slider.lightSlider({
            gallery: true,
            item: 1,
            loop: true,
            slideMargin: 0,
            thumbItem: 9,
            onSliderLoad: function () {
                slider.addClass('lightSlider-initialized');
            },
            });
        }
        });
    },
  },
  beforeMount() {
    this.getProductDetail();
  },
  mounted() {
    this.$watch(
        () => this.images,
        (newImages) => {
        if (newImages && newImages.length) {
            this.initSliderWhenReady();
        }
        }
    );
}
}
</script>
<style scoped>
</style>